<pp-modal [ppScrollOnDefault]="true" [ppWidth]="'690px'">
  <ng-container heading>
    {{ (modalType === ECopyMoveModalType.COPY ? 'copy_points' : 'move_points') | ppTranslate }}

    <div
      ppTooltip
      [ppOptions]="{ placement: 'right' }"
      [ppMobileTooltip]="true"
      [ppSanitize]="false"
      ppTitle="
<div style='text-align: left'>
{{
        (modalType === ECopyMoveModalType.COPY ? 'copy_points_tooltip_1' : 'move_points_tooltip_1')
          | ppTranslate
      }}
<br>
<br>
{{
        (modalType === ECopyMoveModalType.COPY ? 'copy_points_tooltip_2' : 'move_points_tooltip_2')
          | ppTranslate
      }}
</div>"
      class="iconWrapper"
    >
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BADGE_INFO_WHITE]"
        ppColor="white"
        [ppDisplayContents]="true"
        class="info__icon"
      />
    </div>
  </ng-container>

  <ng-container body>
    @if (firstStep) {
      <div>
        <p class="copyMove__header">{{ 'select_destination_site' | ppTranslate }}</p>
        <pp-select-grouped
          [ppItems]="items"
          [ppSelectedItem]="{ name: selectedWorkspaceName, id: selectedWorkspaceId }"
          (ppSelectItem)="selectItem($event)"
        >
          <ng-container selected>
            @if (selectedWorkspaceName) {
              <h6 class="selectList__selected">
                {{ selectedWorkspaceName }}
              </h6>
            }
            @if (!selectedWorkspaceName) {
              <h6 class="selectList__selected">
                {{ 'select_a_site' | ppTranslate }}
              </h6>
            }
          </ng-container>
        </pp-select-grouped>
      </div>
    }

    @if (secondStep && !longProcessing) {
      <div>
        <header class="conflict__header">
          {{
            (modalType === ECopyMoveModalType.COPY ? 'copy_points_to_the' : 'move_points_to_the')
              | ppTranslate
          }}
          {{ selectedWorkspaceName }}
          {{ 'copy_move_points_to_the_site' | ppTranslate }}.
        </header>
        @if (exceedsAttachmentSizeLimit && !hasMultipleCopiesFeatureFlag) {
          <div class="size_error">
            <div class="warningIconWrapper">
              <pp-icon
                [ppSVG]="iconMap[EIconPath.ICON_BANNER_WARNING]"
                [ppDisplayContents]="true"
              />
            </div>

            <div>
              @if (modalType === ECopyMoveModalType.COPY) {
                {{ 'copy_size_error_1' | ppTranslate }}
                <span class="bold_red">{{ currentSizeWithAttachments }}MB</span>.
                {{ 'copy_size_error_2' | ppTranslate }}
                <span class="bold">{{ maxAttachmentSizeMB }}MB</span>.
                {{ 'copy_size_error_3' | ppTranslate }}
              }
              @if (modalType === ECopyMoveModalType.MOVE) {
                {{ 'move_size_error_1' | ppTranslate }}
                <span class="bold_red">{{ currentSizeWithAttachments }}MB</span>.
                {{ 'move_size_error_2' | ppTranslate }}
                <span class="bold">{{ maxAttachmentSizeMB }}B</span>.
                {{ 'move_size_error_3' | ppTranslate }}
              }
            </div>
          </div>
        }
        <pp-field-conflict-list
          [ppFieldConflicts]="fieldConflicts"
          [ppPointPinsToBeCentered]="pointPinsToBeCentered"
          [ppSelectedWorkspaceName]="selectedWorkspaceName"
        ></pp-field-conflict-list>

        @if (integrationWarning) {
          <div class="copyMove__warning">
            <div class="copyMove__warningBox" data-testid="copyMoveIntegrationWarning">
              <div [reactComponent]="VAlert" [props]="vAlertIntegrationProps"></div>
            </div>
          </div>
        }

        @if (hasRelatedPoints && !integrationWarning) {
          <div class="copyMove__warningBox" data-testid="copyMoveRelatedPointsWarning">
            <div [reactComponent]="VAlert" [props]="vAlertRelatedPointsProps"></div>
          </div>
        }
      </div>
    }

    @if (!longProcessing) {
      <div class="copyMove__extras">
        <header class="copyMove__header">{{ 'include' | ppTranslate }}</header>
        @for (item of itemsToInclude; track item) {
          <div>
            <pp-checkbox
              class="copyMove__extras__option"
              [ppChecked]="item.selected"
              (ppOnValueChange)="updateItemsToInclude(item)"
            >
              {{ item.label | ppTranslate }}
              <span class="copyMove__extras__option__size">{{
                item.sizeMB !== null ? ' - ' + item.sizeMB + 'MB' : ''
              }}</span>
            </pp-checkbox>
          </div>
        }
      </div>

      @if (hasMultipleCopiesFeatureFlag && modalType === ECopyMoveModalType.COPY && secondStep) {
        @if (this.sizeMB > 0) {
          <div>
            <p class="copyMove__attachments-total" data-testid="copyMoveAttachmentTotal">
              {{ 'attachment_total' | ppTranslate }}:
              <span
                [class.copyMove__attachments-total__warning]="this.hasExceededMaxAttachmentSize"
              >
                {{ this.currentSizeWithAttachments }}{{ 'mb' | ppTranslate }}
              </span>
              @if (!bypassPointsUploadLimit) {
                {{ 'of' | ppTranslate }}
                {{ this.maxAttachmentSizeMB }}{{ 'mb' | ppTranslate }}
              }
            </p>
          </div>
        }

        <div class="copyMove__numberOfCopies">
          <p>{{ 'number_of_copies' | ppTranslate }}</p>
          <div class="copyMove__numberOfCopies__container">
            <div [reactComponent]="NumberInput" [props]="numberInputProps"></div>
          </div>
        </div>

        @if (this.hasExceededMaxAttachmentSize || this.hasExceededMaxCopiesLimit) {
          <div class="copyMove__warningBox" data-testid="copyMoveLimitError">
            <div [reactComponent]="VAlert" [props]="vAlertErrorProps"></div>
          </div>
        } @else if (this.sizeMB > 0) {
          <div class="copyMove__warningBox" data-testid="copyMovePhotosInfo">
            <div [reactComponent]="VAlert" [props]="vAlertProps"></div>
          </div>
        }
      }
    }

    @if (longProcessing) {
      <h6 class="conflict__list-header conflict__list-header--site">
        {{ 'request_being_processed' | ppTranslate }}
      </h6>
    }
  </ng-container>

  <ng-container footer>
    @if (firstStep) {
      <pp-modal-generic-footer
        [ppHideCancel]="processing"
        [ppConfirmText]="(modalType === ECopyMoveModalType.COPY ? 'next' : 'move') | ppTranslate"
        (ppCancel)="hideModal()"
        (ppConfirm)="check()"
        [ppProcess]="processing"
        [ppDisabled]="!selectedWorkspaceId"
      ></pp-modal-generic-footer>
    }

    @if (secondStep) {
      <pp-modal-generic-footer
        [ppConfirmText]="confirmationButtonText()"
        [ppHideCancel]="processing"
        (ppCancel)="hideModal()"
        (ppConfirm)="confirm()"
        [ppProcess]="processing"
        [ppDisabled]="secondStepDisabled()"
      ></pp-modal-generic-footer>
    }
  </ng-container>
</pp-modal>
